<template>
  <v-app>

    <v-navigation-drawer v-if="!showlogin" app clipped fixed v-model="show_nav">
      <navigation></navigation>
    </v-navigation-drawer>

    <v-toolbar v-if="!showlogin" app clipped-left color="primary" dark flat>
      <v-toolbar-side-icon class="hidden-md-and-up" @click="show_nav = !show_nav"></v-toolbar-side-icon>
      <v-toolbar-title class="white--text">ECO Hosted PABX</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-menu>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>person</v-icon>
          </v-btn>
        </template>
        <usermenu></usermenu>
      </v-menu>

    </v-toolbar>

    <v-content>
      <login v-if="showlogin"></login>
      <router-view v-else></router-view>
    </v-content>

    <v-footer v-if="!showlogin" app class="pa-3">
      <div>{{ accountDescription }}</div>
      <v-spacer></v-spacer>
      <div>&copy; 2019</div>
    </v-footer>

  </v-app>
</template>

<script>
import login from './components/login.vue'
import navigation from './components/navigation.vue'
import usermenu from './components/usermenu.vue'
import Vue from 'vue'
import { store } from './store.js'

export default {
  name: 'App',
  store: store,
  components: {
    login,
    navigation,
    usermenu
  },
  sockets: {
    disconnect: function () {
      this.$store.commit('set_authtoken',null)
    },
    login_result: function (login_res) {
      let new_status = 2
      if (login_res.status === 'ok') {
        new_status = 1
      }
      this.$store.commit('set_ws_login_status',new_status)
    }
  },
  data: () => ({
    show_nav: true,
    requesting_new_token: false
  }),
  methods: {
    checkAuthToken: function () {
      if (this.requesting_new_token) {
        return
      }

      if (!this.$store.getters.auth_token) {
        return
      }
      let time_left = this.$store.getters.auth_exp - this.$store.state.server_time_delta - Math.floor(Date.now() / 1000)

      // log user out if token expired and no activity
      if (time_left < 0) {
        this.$store.commit('set_authtoken',null)
        return
      }

      if (time_left > 100) {
        return
      }

      let last_activity_age = Math.floor(Date.now() / 1000) - this.$store.state.last_activity
      if (last_activity_age > 300) {
        return
      }

      this.requesting_new_token = true
      let that = this
      this.$api.get('/renewtoken', { headers: { 'X-APIReq-Type': 'tokenrenew' } }).then(response => {
        that.requesting_new_token = false
        if (!('token' in response.data)) {
          return
        }
        that.$store.commit('set_authtoken',response.data.token)
        if ('server_time' in response.data) {
          that.$store.commit('set_server_time_delta',response.data.server_time)
        }
      }).catch(e => {
        // ignore unsuccessfull renewal
        this.requesting_new_token = false
      })
    }
  },
  computed: {
    showlogin: function () {
      return (this.$store.state.authtoken == null) || (this.$store.state.ws_login_status != 1)
    },
    accountDescription: function () {
      return this.$store.getters.auth_desc
    }
  },
  beforeMount: function () {
    setInterval(this.checkAuthToken,15000)
  }
}
</script>
